import '../../index.scss';
import Clients from '../Clients/Clients';
import GetInTouch from '../GetInTouch/GetInTouch';
import HeroSection from '../HeroSection/HeroSection';
import Services from '../Services/Services';

const Wrapper = () => {
    return (
        <div id="wrapper">

            <HeroSection />
            <Services />
            <Clients />
            <GetInTouch />

        </div>
    )
}

export default Wrapper